import React, { useEffect, useState } from 'react'
import DealsStages from './DealsGrid/DealsStages'
import { getStages } from 'api/SettingsApi'
import { getDealsApi, getDealsCountApi, putDealApi } from "api/SalesApi"
import styled from '@emotion/styled'
import { DragDropContext } from 'react-beautiful-dnd'
const Container = styled.div`
  display : flex;
  width : 100%;
  overflow-x : scroll;
`
export default function DealsGridView({ pipeline, setShowDealModal, refreshDeals }) {
  const [stages, setStages] = useState([])
  const ALLCOLORS = ['#FFDEC7','#FFC8CF','#CCD5FF', '#F3CCFF', '#CCF1FF']

  useEffect(() => {
    if (pipeline) {
      getStages(pipeline, 100, 0).then((res) => {
        let updatedStages = res
        let promises = updatedStages.map(stage => {
          let sq = `stageId=${stage.id}`
          return getDealsApi(sq)
        })
        Promise.all(promises).then((resolve, reject) => {
          resolve.map((res, index) => {
            updatedStages[index].deals = res
          })
          setStages(updatedStages)
        })
      })
    }
  }, [pipeline, refreshDeals])


  const DragEnd = result => {
    const { destination, source, draggableId } = result;
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }
    putDealApi(result.draggableId, { stage: result.destination.droppableId })
    const sourceStage = stages.find(stage => stage.id === source.droppableId)
    const destinationStage = stages.find(stage => stage.id === destination.droppableId)
    const draggedDeal = sourceStage.deals.find(deal => deal.id === draggableId)

    if (sourceStage.id === destinationStage.id) {
      const newDeals = [...sourceStage.deals]
      newDeals.splice(source.index, 1)
      newDeals.splice(destination.index, 0, draggedDeal)
      sourceStage.deals = newDeals
      setStages([...stages])
    } else {
      const newDeals = [...sourceStage.deals]
      newDeals.splice(source.index, 1)
      sourceStage.deals = newDeals
      setStages([...stages])

      const newDeals2 = [...destinationStage.deals]
      newDeals2.splice(destination.index, 0, draggedDeal)
      destinationStage.deals = newDeals2
      setStages([...stages])
    }
  }

  return (
    <DragDropContext
      onDragEnd={DragEnd}
    >
      <Container>
        {
          stages && stages.map((stage,i) => (
            <DealsStages stage={stage} setShowDealModal={setShowDealModal} headcolor ={ALLCOLORS[i%ALLCOLORS.length]} />
          ))
        }
      </Container>
    </DragDropContext>

  )
}
